import Vue from 'vue'

export default {
  listarCliente: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarCliente{
            id
            nome
            plataforma
            data_cadastro
            token
            device_id
            google_id
            facebook_id
          }
        }`
      }
    })
  },
  listarClienteByNome: (nome) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarCliente(nome: "${nome}"){
            id
            nome
            plataforma
            data_cadastro
            token
            device_id
            google_id
            facebook_id
          }
        }`
      }
    })
  },
  criarCliente: (clienteInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarCliente(data:{
            nome: "${clienteInput.nome}"
            plataforma: "${clienteInput.plataforma}"
            data_cadastro: "${clienteInput.data_cadastro}"
            token: "${clienteInput.token}"
            device_id: "${clienteInput.device_id}"
            google_id: "${clienteInput.google_id}"
            facebook_id: "${clienteInput.facebook_id}"
          }){
            id
            nome
            plataforma
            data_cadastro
            token
            device_id
            google_id
            facebook_id
          }
        }`
      }
    })
  },
  atualizarCliente: (clienteInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarCliente(id: ${clienteInput.id},data:{
            nome: "${clienteInput.nome}"
            plataforma: "${clienteInput.plataforma}"
            data_cadastro: "${clienteInput.data_cadastro}"
            token: "${clienteInput.token}"
            device_id: "${clienteInput.device_id}"
            google_id: "${clienteInput.google_id}"
            facebook_id: "${clienteInput.facebook_id}"
          }){
            id
            nome
            plataforma
            data_cadastro
            token
            device_id
            google_id
            facebook_id
          }
        }`
      }
    })
  },
  deletarCliente: (clienteId) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          deletarCliente(id: ${clienteId})
        }`
      }
    })
  },
  quantidadeCliente: (plataforma) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          quantidadeCliente(plataforma: ${plataforma})
        }`
      }
    })
  },
}
